import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })

export class StorageService {

  private storage = window.localStorage;
  private sessionStorage = window.sessionStorage;

  public removeIdProjeto() {
    this.storage.removeItem('idProjeto');
  }

  public setIdProjeto(id: number) {
    this.storage.setItem('idProjeto', String(id));
  }

  public getIdProjeto() {
    return Number(this.storage.getItem('idProjeto'));
  }

  public removeProjeto() {
    this.storage.removeItem('projeto');
  }

  public setProjeto(obj) {
    this.storage.setItem('projeto', JSON.stringify(obj));
  }

  public getProjeto() {
    return JSON.parse(this.storage.getItem('projeto'));
  }

  public removeInfoUser() {
    this.storage.removeItem('infoUser');
  }

  public setInfoUser(user) {
    this.storage.setItem('infoUser', JSON.stringify(user));
  }

  public getInfoUser() {
    return JSON.parse(this.storage.getItem('infoUser'));
  }

  public setFilterValue(key: string, values: any) {
    this.sessionStorage.setItem(key, JSON.stringify(values));
  }

  public getFilterValue(key: string) {
    return JSON.parse(this.sessionStorage.getItem(key));
  }

  public removeFilterValue(key: string) {
    this.sessionStorage.removeItem(key);
  }

  public removeFilterAll() {
    const keysToRemove = [];
    this.sessionStorage.removeItem('filterPreProjetoValue');
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key.startsWith('filter')) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      sessionStorage.removeItem(key);
    }
  }

  public setWelcomeDate() {
    this.storage.setItem('welcomeDate', String(new Date()));
  }

  public getWelcomeDate() {
    return new Date(this.storage.getItem('welcomeDate'));
  }

  /**
   * Função para validar a exibição atual do modal de bem-vindo. Controla a sessão para o mesmo em chamadas futuras.
   * @returns Se exibe ou não o Welcome na tela chamada
   */
  public showWelcome(): boolean {
    let dataSessao = new Date(this.getWelcomeDate());
    let dataHoje = new Date();
    var retorno = false;

    const dataSessaoNormalized = new Date(dataSessao.getFullYear(), dataSessao.getMonth(), dataSessao.getDate());
    const dataHojeNormalized = new Date(dataHoje.getFullYear(), dataHoje.getMonth(), dataHoje.getDate());

    if (dataHojeNormalized.getTime() > dataSessaoNormalized.getTime()) {
      this.setWelcomeDate();
      retorno = true;
    }
    
    return retorno;
  }
}
